// extracted by mini-css-extract-plugin
export default {"contenedor":"error_contenedor__gfr3A","principal":"error_principal__bqkSE","titulo":"error_titulo__i8YUF","subtitulo":"error_subtitulo__WC8Rb","imagen":"error_imagen__WiK9r"};